"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.externalLoginToken = exports.loginApiToken = void 0;
var Api_1 = require("@/api/remote/Api");
exports.loginApiToken = function (fields, languageCode, token) {
    return Api_1.api().request({
        method: 'POST',
        url: languageCode + "/api/account/login",
        headers: {
            'X-XSRF-TOKEN': token,
        },
        data: {
            email: fields.email,
            password: fields.password,
            rememberMe: fields.rememberMe,
        },
    });
};
exports.externalLoginToken = function (provider, externalToken, languageCode, token) {
    return Api_1.api().request({
        method: 'POST',
        url: languageCode + "/api/account/externalLogin",
        headers: {
            'X-XSRF-TOKEN': token,
        },
        data: {
            provider: provider,
            externalToken: externalToken,
        },
    });
};
